import { Payment } from '@klear/payment/payment'
import { PAYMENT_TYPE_SUPPLIER } from '@klear/payment/constants'
import type { Payable } from '@klear/payable/payable'

export function paymentFromPayable(payable: Payable): Payment {
  return new Payment({
    id: payable.paymentId ?? 0,
    paymentType: PAYMENT_TYPE_SUPPLIER,
    paymentNetwork: payable.network,
    effectiveDate: payable.effectiveDate,
    amount: payable.amount,
    notes: payable.notes || undefined,
    internalNotes: payable.internalNotes || undefined,
    statementDescriptor: payable.statementDescriptor || undefined,
    notifySupplier: payable.notifySupplier,
    number: payable.number || undefined,
    operationalEventId: payable.operationalId,
    orderId: payable.orderId,
    status: payable.status,
    sourceAccountType: payable.sourceAccountType,
    sourceAccountId: payable.sourceAccountId,
    sourceAccountOrganizationId: payable.sourceAccountOrganizationId,
    sourceAccountOrganizationName: payable.sourceAccountOrganizationName,
    destinationAccountType: payable.destinationAccountType,
    destinationAccountId: payable.destinationAccountId,
    destinationAccountOrganizationId: payable.destinationAccountOrganizationId,
    destinationAccountOrganizationName: payable.destinationAccountOrganizationName,
    payableId: payable.id
  })
}
